<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" role="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">Text Editor</h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<div class="content">
  <h2>Text Editor Use Case 1 : ngModel</h2>
  <maced-text-editor textEditorId="textEditorId1" [isShortCutKeyEnable]="true" [modules]="modules" editertextId="textditeride" [(ngModel)]="textEditorNgModel"></maced-text-editor>
  <div class="result-class">
    Result:- {{ textEditorNgModel }}
  </div>

  <h2>Text Editor Use Case 2 : Widget Customization</h2>
  <maced-text-editor textEditorId="textEditorId2" [isShortCutKeyEnable]="true" [modules]="customModules" editertextId="textditeridd" [(ngModel)]="textEditorCustom"></maced-text-editor>
  <div class="result-class">
    Result:- {{ textEditorCustom }}
  </div>

  <h2>Text Editor Use Case 3 : Form Control</h2>
  <maced-text-editor textEditorId="textEditorId3" [modules]="modules" editertextId="textditeridc" [formControl]="textEditorFormControl"></maced-text-editor>
  <div class="result-class">
    Result:- {{ textEditorFormControl.value }}
  </div>

  <h2>Text Editor Use Case 4 : Angular Form</h2>
  <form [formGroup]="form" (ngSubmit)="submitForm($event)" id="form1">
    <maced-text-editor textEditorId="textEditorId4" [modules]="modules" formControlName="textEditor" editertextId="textditeridb" ></maced-text-editor>
    <span class="c-input-group__error"
      *ngIf="(form.controls.textEditor.touched || submitted) && form.controls.textEditor.errors?.required">
      This field is required
    </span>
    <div class="result-class">
      Result:- {{ form.controls.textEditor.value }}
    </div>
    <br>
    <h2>Text Editor Use Case 5 : Angular Form with formID</h2>

    <maced-text-editor textEditorId="textEditorId5" [modules]="modules" editertextId="textditerida" formControlName="textEditorWithFormID" name="textEditorWithFormID" formID="form1"></maced-text-editor>
    <span class="c-input-group__error"
      *ngIf="(form.controls.textEditorWithFormID.touched || submitted) && form.controls.textEditorWithFormID.errors?.required">
      This field is required
    </span>
    <br>
    <button type="submit" id="buttonIdsave">submit from inside form</button>
  </form>
  <br>
  <button type="submit" form="form1">submit from outside form</button>
  <div class="result-class">
    Result:- 
      {{ formControlData?.textEditorWithFormID.value }}
  </div>
</div>